/*
	Recursively removes unnecessary fields from fetched data to use it for form data.
	Default removing fields ('__typename') can be extended by 'excluded' argument.
*/

const fetchedDataToForm = (dataObj, excludedFields = []) => typeof dataObj !== 'object' || dataObj === null ? dataObj : Object.keys(dataObj).reduce((out, field) => {
	if(field === '__typename' || (Array.isArray(excludedFields) && excludedFields.some(item => item === field))) {
		return out
	}
	const fieldVal = dataObj[field]
	if(Array.isArray(fieldVal)) {
		return { ...out, [field]: fieldVal.map(item => fetchedDataToForm(item, excludedFields)) }
	}
	if(typeof fieldVal === 'object') {
		return { ...out, [field]: fetchedDataToForm(fieldVal) }
	}
	return { ...out, [field]: fieldVal }
}, {})

export default fetchedDataToForm
